const listeners = new Set();
let toastId = 0;

const subscribeToToasts = (listener) => {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
};

const publishToast = (toast) => {
    listeners.forEach((listener) => listener(toast));
};

const buildMessage = (error) => {
    if (typeof error === "string") {
        return error;
    }

    if (!error) {
        return "Something went wrong.";
    }

    const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.title ||
        error?.response?.data?.detail;

    if (apiMessage) {
        return apiMessage;
    }

    if (error?.message) {
        return error.message;
    }

    return "Something went wrong.";
};

const notifyToast = (message, options = {}) => {
    const toast = {
        id: (toastId += 1),
        message,
        severity: options.severity ?? "info",
        duration: options.duration ?? 4000,
    };

    publishToast(toast);

    return toast.id;
};

const notifyError = (error, options = {}) => {
    const message = options.message ?? buildMessage(error);

    return notifyToast(message, {
        severity: "error",
        duration: options.duration,
    });
};

export { notifyError, notifyToast, subscribeToToasts };
